export const ChevronDownIcon = () => {
  return (
    <svg
      width='16'
      height='11'
      viewBox='0 0 16 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.01966 10.3615C7.80952 10.3617 7.6014 10.3197 7.40727 10.2378C7.21314 10.156 7.03683 10.0359 6.88846 9.88448L0.488461 3.373C0.335645 3.22283 0.213753 3.04321 0.129899 2.8446C0.0460446 2.64599 0.00190652 2.43238 6.04113e-05 2.21624C-0.00178569 2.00009 0.0386967 1.78573 0.119146 1.58567C0.199596 1.38561 0.318401 1.20386 0.468629 1.05101C0.618857 0.898167 0.7975 0.777293 0.994135 0.695442C1.19077 0.613591 1.40146 0.572402 1.6139 0.57428C1.82635 0.576158 2.0363 0.621065 2.23151 0.706381C2.42671 0.791696 2.60327 0.915711 2.75086 1.07119L8.01966 6.43161L13.2885 1.07119C13.5902 0.77466 13.9944 0.61058 14.4139 0.614289C14.8334 0.617998 15.2347 0.789199 15.5314 1.09102C15.828 1.39284 15.9963 1.80113 15.9999 2.22795C16.0036 2.65478 15.8423 3.06598 15.5509 3.373L9.15086 9.88448C9.00249 10.0359 8.82618 10.156 8.63205 10.2378C8.43792 10.3197 8.2298 10.3617 8.01966 10.3615Z'
        fill='#898989'
      />
    </svg>
  );
};
